// src/hooks/NovuProvider.tsx
import { Novu } from "@novu/js";
import { buildSubscriber } from "@novu/js/internal";
import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var NovuContext = createContext(void 0);
var NovuProvider = (props) => {
  const { subscriberId, ...propsWithoutSubscriberId } = props;
  const subscriberObj = useMemo(
    () => buildSubscriber({ subscriberId, subscriber: props.subscriber }),
    [subscriberId, props.subscriber]
  );
  const applicationIdentifier = propsWithoutSubscriberId.applicationIdentifier ? propsWithoutSubscriberId.applicationIdentifier : "";
  const providerProps = {
    ...propsWithoutSubscriberId,
    applicationIdentifier,
    subscriber: subscriberObj
  };
  return /* @__PURE__ */ jsx(InternalNovuProvider, { ...providerProps, applicationIdentifier, children: props.children });
};
var InternalNovuProvider = (props) => {
  const applicationIdentifier = props.applicationIdentifier || "";
  const subscriberObj = useMemo(
    () => buildSubscriber({ subscriberId: props.subscriberId, subscriber: props.subscriber }),
    [props.subscriberId, props.subscriber]
  );
  const {
    children,
    subscriberHash,
    contextHash,
    backendUrl,
    apiUrl,
    socketUrl,
    socketOptions,
    useCache,
    defaultSchedule,
    context
  } = props;
  const novu = useMemo(
    () => new Novu({
      applicationIdentifier,
      subscriberHash,
      contextHash,
      backendUrl,
      apiUrl,
      socketUrl,
      socketOptions,
      useCache,
      subscriber: subscriberObj,
      defaultSchedule,
      context
    }),
    [
      applicationIdentifier,
      subscriberHash,
      subscriberObj,
      context,
      contextHash,
      backendUrl,
      apiUrl,
      socketUrl,
      socketOptions,
      useCache
    ]
  );
  return /* @__PURE__ */ jsx(NovuContext.Provider, { value: novu, children });
};
var useNovu = () => {
  const context = useContext(NovuContext);
  if (!context) {
    throw new Error("useNovu must be used within a <NovuProvider />");
  }
  return context;
};
var useUnsafeNovu = () => {
  const context = useContext(NovuContext);
  return context;
};
export {
  InternalNovuProvider,
  NovuProvider,
  useNovu,
  useUnsafeNovu
};
//# sourceMappingURL=NovuProvider.js.map